import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphUTMSource } from "./utmSourceAPI";
import { UTMdataFilter } from "../../../../helper";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  visitors: [],
  percentBooking: [],
  percentBought: [],
  weeks: [],
  labels: [],
};

export const graphUTMSource = createAsyncThunk(
  "utmSource/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-utm_source`;
      const response = await fetchGraphUTMSource(dbpath, user, 'graph-utm_source');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const utmSourceSlice = createSlice({
  name: "utmSource",
  initialState,
  reducers: {
    resetUtmSource: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUTMSource.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUTMSource.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result;
          const resultData = utmSourceHandler(result, "utm_source=");
          state.visitors = resultData.visitors.reverse();
          state.percentBooking = resultData.percentBooking.reverse();
          state.percentBought = resultData.percentBought.reverse();
          state.weeks = resultData.weeks.reverse();
          state.labels = resultData.labels.reverse();
        } catch (error) {
          // console.warn("UTMSource data not found!", error)
        }
      })
      .addCase(graphUTMSource.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetUtmSource} = utmSourceSlice.actions;


export const SelectVisitors = (state) => state.utmSource.visitors;
export const SelectPercentBooking = (state) => state.utmSource.percentBooking;
export const SelectPercentBought = (state) => state.utmSource.percentBought;
export const SelectLabels = (state) => state.utmSource.labels;
export const SelectWeeks = (state) => state.utmSource.weeks;
export const SelectUTMSourceStatus = (state) => state.utmSource.status;

export default utmSourceSlice.reducer;

export const utmSourceHandler = (data, utmParam) => {
  let resultObj = {
    weeks: [],
    visitors: [],
    percentBooking: [],
    percentBought: [],
    labels: [],
  };

  const resultData =  UTMdataFilter(data, resultObj, utmParam);
  return resultData;
};

